import "core-js/stable";
import "regenerator-runtime/runtime";

import React, { StrictMode } from "react";

import {
  APP_INIT_ERROR,
  APP_READY,
  initialize,
  mergeConfig,
  subscribe,
} from "@edx/frontend-platform";
import { ErrorPage } from "@edx/frontend-platform/react";
import { createRoot } from "react-dom/client";

import configuration from "./config";
import messages from "./i18n";
import MainApp from "./MainApp";
import faviconUrl from "./assets/favicon.ico";

// Dynamically set favicon to override Open edX default
const setFavicon = () => {
  // Remove all existing favicons
  const existingFavicons = document.querySelectorAll("link[rel*='icon']");
  existingFavicons.forEach((el) => el.remove());

  // Add new favicon
  const link = document.createElement("link");
  link.rel = "icon";
  link.type = "image/x-icon";
  link.href = faviconUrl;
  document.head.appendChild(link);
};

subscribe(APP_READY, () => {
  // Override Open edX favicon
  setFavicon();
  const root = createRoot(document.getElementById("root"));

  root.render(
    <StrictMode>
      <MainApp />
    </StrictMode>,
  );
});

subscribe(APP_INIT_ERROR, (error) => {
  const root = createRoot(document.getElementById("root"));

  root.render(
    <StrictMode>
      <ErrorPage message={error.message} />
    </StrictMode>,
  );
});

initialize({
  handlers: {
    config: () => {
      mergeConfig(configuration);
    },
  },
  messages,
});
